<template>
  <div class="login-card__location-card step-primary step-primary--4">
    <div>
      <div class="login-card__big-icon">
        <img src="../../../images/registration/location.png" alt="">
      </div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <div class="row">
          <div class="col-12">
            <validation-provider name="data" v-slot="{ errors }" mode="eager">
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
            <validation-provider name="name" v-slot="{ errors }" mode="eager">
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <form @submit.prevent="handleSubmit(onSubmit)">
          <input-location class="input" v-model="form.location_id"></input-location>

          <div class="login-card__title-box">
            <h1 class="login-card__title login-card__title--location-header" id="location-header">{{ trans.get('auth.card.city.header') }}</h1>

            <p class="login-card__title-desc">{{ trans.get('auth.card.city.subheader') }}</p>
          </div>

          <button type="submit" class="button__auth">
            <!--                        {{trans.get('auth.card.buttons.next_step')}}-->
            {{ trans.get('auth.card.buttons.finished') }}
            <img src="../../../images/registration/arrow-right.svg" class="registration-button-arrow" />
          </button>
        </form>
      </validation-observer>

      <Step :step="4"></Step>

      <button type="button" class="button button__link button--back" @click="swapComponent('auth-birthday-card')">
        <i class="demo-icon icon-left"> </i>
        <span>{{ trans.get('auth.card.buttons.back') }}</span>
      </button>
    </div>
  </div>

</template>
<script>
import InputLocation from './InputLocation';
import moment from 'moment';
import AuthGoBackMixin from './../../../../js/front/components/Auth/AuthGoBackMixin';
import Step from './Step';

export default {
  components: { InputLocation, Step },
  props: ['swapComponent', 'form'],
  mixins: [AuthGoBackMixin],
  methods: {
    onSubmit() {
      axios
        .put(zRoute('register.update'), this.getPreparedData())
        .then((response) => {
          if (response.data.status === 'success') {
            window.localStorage.removeItem('campaign_cid');
            window.localStorage.removeItem('campaign_eid');
            window.localStorage.removeItem('campaign_query');
            // this.swapComponent('auth-registration-success-card');

            this.$store.dispatch('analytics/gtagEvent', {
              event: 'doi',
              p: {
                'event_category': 'User Registration',
                'event_label': 'DOI Registration'
              }
            });

            setTimeout(() => {
              window.location.href = zRoute('front.members.index');
            }, 100);
          } else {
            this.$refs.form.setErrors({ data: [this.trans.get('auth.card.data_update_failed')] });
          }
        })
        .catch((error) => {
          const errors = error.response.data.errors;

          if (error.response.status === 422) {
            this.$refs.form.setErrors(errors);
          }
        });
    },
    getPreparedData() {
      let preparedData = JSON.parse(JSON.stringify(this.form));
      preparedData.birth_date = moment(this.form.birth_date, 'DD MM YYYY').format('YYYY-MM-DD');
      preparedData.cid = window.localStorage.getItem('campaign_cid');
      preparedData.eid = window.localStorage.getItem('campaign_eid');
      preparedData.campaign_query = window.localStorage.getItem('campaign_campaign_query');

      if (!preparedData.preferred_gender || !preparedData.preferred_gender[0]) {
        preparedData.preferred_gender = ['female'];
      }

      return preparedData;
    },
    goBack() {
      this.swapComponent('auth-birthday-card');
    }
  },
  activated() {
    this.$emit('update:progress', 100);
  }
};
</script>
<style scoped>
</style>
